export const event_service = {

    FETCH_EVENT_SERVICES_SUCCESS: 'FETCH_EVENT_SERVICES_SUCCESS',
  
    FETCH_EVENT_SERVICES_LOADING: 'FETCH_EVENT_SERVICES_LOADING',
    
};
  